import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { Country } from '../models/country';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class CountryService {

    controller = 'country';

    constructor(private base: BaseService) { }

    get(id): Observable<ApiObjectData> {
        return this.base.get(id, this.controller);
    }

    gets(): Observable<ApiObjectData> {
        return this.base.gets(this.controller);
    }

    save(obj: Country) {
        return this.base.save(this.controller, obj);
    }

    remove(id: number) {
        return this.base.remove(this.controller, id);
    }
}
